import { useAPI } from "./useAPI";

export type FeedbackData = {
  messageID: string;
  threadID: string;
  runID: string;
  correctness: number;
  tags: string[];
  comments: string;
};

/**
 * Hook for listening for and sending feedback to the backend.
 * @returns The feedback data and a loading state.
 */
export const useFeedbackAPI = () => {
  const { $post } = useAPI();

  const sendFeedback = async (
    data: FeedbackData,
    onSuccess?: () => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (error: any) => void,
  ) => {
    await $post("/frontend/feedback", {
      message_id: data.messageID,
      thread_id: data.threadID,
      run_id: data.runID,
      correctness: data.correctness,
      tags: data.tags,
      comments: data.comments,
    })
      .then(() => onSuccess?.())
      .catch((error) => onError?.(error));
  };

  return { sendFeedback };
};
